import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Col, UncontrolledTooltip } from 'reactstrap';
import { dateToString } from '../../../common/utils/date/Date.utils';
import { preparePriceFormat } from '../../../common/helpers/preparePriceFormat';
import { downloadInvoice, downloadInvoiceCreditNote } from '../../SettingsActions';

const CreditFacilityStatus = {
  PAID: 'PAID',
  UNPAID: 'UNPAID',
};

function InvoiceTableRow({ item }) {
  const dispatch = useDispatch();

  const resolveStatusChipClassName = () => {
    if (item.hasCreditNote) return 'invoice-status-chip--refunded';
    if (
      item.creditFacilityStatus === CreditFacilityStatus.PAID ||
      !item.isCreditFacilityInvoice
    )
      return 'invoice-status-chip--paid';
    return 'invoice-status-chip--unpaid';
  };

  const resolveStatusChipLabel = () => {
    if (item.hasCreditNote) {
      return 'REFUNDED';
    }
    if (item.isCreditFacilityInvoice) return item.creditFacilityStatus;
    return CreditFacilityStatus.PAID;
  };

  return (
    <>
      <td className="cropped-row-cell">{dateToString(item?.createdOn)}</td>
      <td className="cropped-row-cell">{item.invoiceNumber}</td>
      <td className="cropped-row-cell">
        {item.isCreditFacilityInvoice ? 'Credit Facility' : 'Credit Card'}
      </td>
      <td>
        <span className="font-weight-bold mr-1">
          {preparePriceFormat(item.totalAmountInPence, true)}
        </span>
      </td>
      <td className={`cropped-row-cell invoice-status-chip ${resolveStatusChipClassName()}`}>
        {resolveStatusChipLabel()}
      </td>
      <td>
        <button
          id={`tooltip_download_${item?.id || item?.invoiceNumber}`}
          type="button"
          className="invoice-table-row__action-button"
          aria-label="Invoice actions"
          onClick={() => {
            if (item.hasCreditNote) return;
            dispatch(downloadInvoice({ id: item?.id, invoiceNumber: item?.invoiceNumber }));
          }}
        >
          <span className="sr-only">Invoice actions</span>
        </button>

        {item.hasCreditNote && (
          <UncontrolledTooltip
            target={`tooltip_download_${item?.id ?? item?.invoiceNumber}`}
            delay={{ show: 100, hide: 100 }}
            autohide={false}
            innerClassName="m-0 p-0"
            className="invoices-table__tooltip"
            container="body"
            placement="bottom"
          >
            <Col className="invoices-table__tooltip">
              <Col
                className="invoices-table__tooltip-btn cursor-pointer card-title btn-primary"
                onClick={() => {
                  dispatch(
                    downloadInvoice({ id: item?.id, invoiceNumber: item?.invoiceNumber }),
                  );
                }}
              >
                Download invoice
              </Col>
              <Col
                className="invoices-table__tooltip-btn cursor-pointer card-title btn-primary"
                onClick={() => {
                  dispatch(downloadInvoiceCreditNote(item?.id));
                }}
              >
                Download credit note
              </Col>
            </Col>
          </UncontrolledTooltip>
        )}
      </td>
    </>
  );
}

InvoiceTableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default InvoiceTableRow;
